import { canvasAssetsStore, readNodeCustomDataSnapshot, type CanvasAsset } from '@/entities/node'
import type { GroupTaskExecutionContext, NodeContextPayloadLike } from '@/shared/lib/node-registry'
import { readContextPayloadEstimatedItemCount, readListNodeAssetRefs } from '../list-node-operation'

function createEstimatedCanvasAsset(payload: NodeContextPayloadLike, index: number): CanvasAsset {
  const isText = payload.kind === 'text' || payload.kind === 'text-list'
  const isAudio = payload.kind === 'audio' || payload.kind === 'audio-list'
  const isVideo = payload.kind === 'video' || payload.kind === 'video-list'

  return {
    id: `estimated:${payload.nodeId}:${index}`,
    title: payload.title,
    type: isText ? 'text' : isAudio ? 'audio' : isVideo ? 'video' : 'image',
    width: 512,
    height: 512,
  }
}

export function resolveContextCanvasAssets(
  contextPayloads: NodeContextPayloadLike[],
  acceptedKinds: string[],
  groupExecution?: GroupTaskExecutionContext,
): CanvasAsset[] {
  const payloads = contextPayloads.filter((payload) => acceptedKinds.includes(payload.kind))
  const assets: CanvasAsset[] = []

  for (const payload of payloads) {
    const assetStartIndex = assets.length
    const snapshot = readNodeCustomDataSnapshot(payload.nodeId)
    const assetRefs = readListNodeAssetRefs(snapshot)
    for (const assetId of assetRefs) {
      const asset = canvasAssetsStore.assets.get(assetId)
      if (asset) assets.push(asset)
    }

    const estimatedCount = readContextPayloadEstimatedItemCount(payload, groupExecution)
    const resolvedAssetCount = assets.length - assetStartIndex
    if (!estimatedCount || estimatedCount <= resolvedAssetCount) continue

    for (let index = resolvedAssetCount; index < estimatedCount; index += 1) {
      assets.push(createEstimatedCanvasAsset(payload, index))
    }
  }

  return assets
}
